// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"711":"102e77e6","1235":"5c4d2574","2375":"21cdaccd","4579":"54630aa6"}[chunkId] + ".chunk.css";
};